import React from 'react';
import PropTypes from 'prop-types';

import Tags from 'components/Tags';

import Location from './Location';

const Footer = ({ location, secret_location, organizationTags, tag_ids }) => {

  const hasTags = tag_ids && tag_ids.length > 0;

  if (!location && !secret_location && !hasTags) return null;

  return (
    <>
      <Tags tag_ids={tag_ids} organizationTags={organizationTags}/>
      <Location location={location} secret_location={secret_location} />
    </>
  );
};

Footer.propTypes = {
  location: PropTypes.string,
  secret_location: PropTypes.bool,
  organizationTags: PropTypes.array,
  tag_ids: PropTypes.array
};

export default Footer;
